import { render } from "./uploadStudyProtocol.vue?vue&type=template&id=11b9feae&scoped=true"
import script from "./uploadStudyProtocol.js?vue&type=script&lang=js"
export * from "./uploadStudyProtocol.js?vue&type=script&lang=js"

import "./uploadStudyProtocol.vue?vue&type=style&index=0&id=11b9feae&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b9feae"]])

export default __exports__